/*
 * Copyright 2025 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import DefaultBotIcon from './icons/caipe.png';

export const DEFAULT_BOT_CONFIG = {
  name: 'CAIPE',
  icon: DefaultBotIcon,
} as const;

export const DEFAULT_SUGGESTIONS = [
  'What can you do?',
  'How do I configure agents?',
  'Help me with platform engineering tasks',
];

export const DEFAULT_THINKING_MESSAGES = [
  '🤖 Contacting agents',
  '⚙️ Processing query',
  '📦 Carrying bits',
  '📊 Analyzing data',
];
